// 产品信息 包含产品名称、图片、背景故事；收藏、分享、获得积分共呢import React from 'react'
import React from 'react'
import { Col, Container, Input, InputGroup, Row } from 'reactstrap' 
 

const CollectList = () => { 

    document.title="CollectList";
    return (
        <React.Fragment> 
                <div className="auth-page-content">
                    <Container>
                        <Row>
                            <Col lg={12}>
                                <div className="text-center mt-sm-5 pt-4 mb-4">
                                    <div className="mb-sm-5 pb-sm-4 pb-5">
                                    CollectList
                                    </div> 
                                </div>
                            </Col>
                        </Row>

                    </Container>

                </div> 
        </React.Fragment>
    )
}

export default CollectList